/**
 * bundle-builder.js
 * Toegevoegd 5 okt 2026. Hoort bij snippets/bundle-picker.liquid
 * (alleen de gewone 15/20/25%-kiezer, herkenbaar aan data-bundle-builder).
 *
 * Maakt van de vaste 1/2/3-kiezer een open bundel:
 *   - staffelbalk bovenaan kleurt groen per gehaalde staffel, en is klikbaar
 *   - knop "Add item N" voegt een rij toe (eigen kleur + maat per stuk)
 *   - de 3-stuks-kaart toont het echte aantal, de korting en de prijs
 *   - regel onder de knop: hoeveel er nog bij moet voor de volgende korting
 *
 * Toevoegen aan de winkelwagen doet dit bestand NIET. Dat blijft
 * assets/bundle-picker.js doen; die leest alle rijen van de zichtbare kaart,
 * dus de extra rijen gaan vanzelf mee. De korting zelf komt van de
 * automatische Shopify-kortingen, net als voorheen.
 */
(function () {
  'use strict';

  function maakGeld(valuta) {
    return function (centen) {
      if (window.theme && theme.Currency && theme.Currency.formatMoney && theme.settings) {
        try { return theme.Currency.formatMoney(centen, theme.settings.moneyFormat); } catch (e) {}
      }
      try {
        return new Intl.NumberFormat(valuta === 'GBP' ? 'en-GB' : 'en-US', {
          style: 'currency', currency: valuta || 'USD'
        }).format(centen / 100);
      } catch (e) {
        return '$' + (centen / 100).toFixed(2);
      }
    };
  }

  function leesStaffel(rauw) {
    return String(rauw || '').split('|').map(function (deel) {
      var b = deel.split(':');
      return { qty: parseInt(b[0], 10), pct: parseInt(b[1], 10) };
    }).filter(function (t) { return t.qty && !isNaN(t.pct); })
      .sort(function (a, b) { return a.qty - b.qty; });
  }

  function init(picker) {
    if (picker.__builderInit || !picker.hasAttribute('data-bundle-builder')) return;
    picker.__builderInit = true;

    var staffel = leesStaffel(picker.getAttribute('data-staffel'));
    var maxStuks = parseInt(picker.getAttribute('data-max'), 10) || 20;
    var prijs = parseInt(picker.getAttribute('data-price'), 10) || 0;
    var vergelijk = parseInt(picker.getAttribute('data-compare'), 10) || prijs;
    var kortingTekst = picker.getAttribute('data-save-text') || 'Extra [discount] discount';
    var geld = maakGeld(picker.getAttribute('data-currency'));

    var varianten = [];
    try {
      varianten = JSON.parse(picker.querySelector('[data-bundle-varianten-json]').textContent);
    } catch (e) { varianten = []; }

    var laatsteKaart = picker.querySelector('[data-bundle-optie][data-bundle-laatste]');
    var laatsteBlok = picker.querySelector('[data-bundle-varianten][data-bundle-laatste]');
    if (!laatsteKaart || !laatsteBlok) return;
    var basisAantal = parseInt(laatsteBlok.getAttribute('data-qty'), 10) || 3;

    var titelEl = laatsteKaart.querySelector('[data-bundle-titel]');
    var basisTitel = titelEl ? titelEl.textContent : '';

    /* ---------- hulpjes ---------- */

    function pctVoor(n) {
      var p = 0;
      staffel.forEach(function (t) { if (n >= t.qty) p = t.pct; });
      return p;
    }

    function volgendeTrede(n) {
      for (var i = 0; i < staffel.length; i++) if (staffel[i].qty > n) return staffel[i];
      return null;
    }

    function zichtbaarBlok() {
      var blokken = picker.querySelectorAll('[data-bundle-varianten]');
      for (var i = 0; i < blokken.length; i++) if (!blokken[i].hidden) return blokken[i];
      return null;
    }

    function gekozenAantal() {
      var blok = zichtbaarBlok();
      if (blok) return blok.querySelectorAll('[data-bundle-item]').length;
      var radio = picker.querySelector('[data-bundle-radio]:checked');
      return radio ? (parseInt(radio.value, 10) || 1) : 1;
    }

    function rijenVan(blok) {
      return blok.querySelectorAll('[data-bundle-item]');
    }

    function waardenVan(rij) {
      return Array.prototype.map.call(
        rij.querySelectorAll('[data-bundle-optie-naam]'),
        function (s) { return s.value; }
      );
    }

    function zetWaarden(rij, waarden) {
      var selects = rij.querySelectorAll('[data-bundle-optie-naam]');
      Array.prototype.forEach.call(selects, function (s, i) {
        if (waarden[i] != null && s.value !== waarden[i]) s.value = waarden[i];
      });
    }

    function variantVoor(waarden) {
      for (var i = 0; i < varianten.length; i++) {
        var v = varianten[i];
        var opts = [v.option1, v.option2, v.option3];
        var raak = true;
        for (var j = 0; j < waarden.length; j++) {
          if (opts[j] !== waarden[j]) { raak = false; break; }
        }
        if (raak) return v;
      }
      return null;
    }

    /* Welke dropdown is de kleur? Op naam; anders de eerste. */
    function kleurIndex(rij) {
      var selects = rij.querySelectorAll('[data-bundle-optie-naam]');
      for (var i = 0; i < selects.length; i++) {
        if (/colou?r|kleur|shade/i.test(selects[i].getAttribute('data-bundle-optie-naam'))) return i;
      }
      return selects.length > 1 ? 0 : -1;
    }

    /*
      Waarden voor een nieuwe rij: maat (en de rest) van de rij erboven,
      kleur = de eerste die nog niet gekozen is en op voorraad is in die maat.
      Alles al gekozen? Dan gewoon dezelfde als de rij erboven.
    */
    function waardenNieuweRij(blok) {
      var rijen = rijenVan(blok);
      var vorige = rijen[rijen.length - 1];
      var basis = waardenVan(vorige);
      var ki = kleurIndex(vorige);
      if (ki === -1) return basis;

      var gebruikt = {};
      Array.prototype.forEach.call(rijen, function (r) { gebruikt[waardenVan(r)[ki]] = true; });

      var opties = vorige.querySelectorAll('[data-bundle-optie-naam]')[ki].options;
      var reserve = null;
      for (var i = 0; i < opties.length; i++) {
        var kandidaat = basis.slice();
        kandidaat[ki] = opties[i].value;
        var v = variantVoor(kandidaat);
        if (!v || v.available === false) continue;
        if (!gebruikt[opties[i].value]) return kandidaat;
        if (!reserve) reserve = kandidaat;
      }
      return reserve || basis;
    }

    function stuur(el) {
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* ---------- rijen toevoegen / weghalen ---------- */

    function nummerRijen(blok) {
      Array.prototype.forEach.call(rijenVan(blok), function (rij, i) {
        rij.setAttribute('data-bundle-item', i + 1);
        Array.prototype.forEach.call(rij.querySelectorAll('[data-bundle-optie-naam]'), function (s) {
          s.setAttribute('aria-label', s.getAttribute('data-bundle-optie-naam') + ' - Item ' + (i + 1));
        });
      });
    }

    function voegRijToe(blok) {
      var rijen = rijenVan(blok);
      if (rijen.length >= maxStuks) return;
      var waarden = waardenNieuweRij(blok);
      var nieuw = rijen[rijen.length - 1].cloneNode(true);
      nieuw.classList.add('bundelkiezer__item--extra');

      if (!nieuw.querySelector('[data-bundle-weg]')) {
        var weg = document.createElement('button');
        weg.type = 'button';
        weg.className = 'bundelkiezer__weg';
        weg.setAttribute('data-bundle-weg', '');
        weg.setAttribute('aria-label', 'Remove item');
        weg.innerHTML = '&times;';
        nieuw.appendChild(weg);
      }

      blok.querySelector('[data-bundle-rijen]').appendChild(nieuw);
      zetWaarden(nieuw, waarden);
      nummerRijen(blok);
      /* Laat bundle-picker.js het miniatuurtje en de grote foto bijwerken. */
      var eerste = nieuw.querySelector('[data-bundle-optie-naam]');
      if (eerste) stuur(eerste);
    }

    /*
      Op de 2-stuks-kaart: niet daar een rij bijplakken, maar doorschakelen
      naar de 3-stuks-kaart en de twee keuzes meenemen. Anders staan er twee
      kaarten met "3 Items" op het scherm.
    */
    function naarLaatsteKaart(vanBlok) {
      var keuzes = Array.prototype.map.call(rijenVan(vanBlok), waardenVan);
      var radio = laatsteKaart.querySelector('[data-bundle-radio]');
      radio.checked = true;
      stuur(radio);

      var rijen = rijenVan(laatsteBlok);
      keuzes.forEach(function (w, i) { if (rijen[i]) zetWaarden(rijen[i], w); });
      /* De rij die er nieuw bij komt krijgt een kleur die nog vrij is. */
      if (rijen[keuzes.length]) {
        var tijdelijk = rijen[keuzes.length];
        tijdelijk.parentNode.removeChild(tijdelijk);
        var w = waardenNieuweRij(laatsteBlok);
        laatsteBlok.querySelector('[data-bundle-rijen]').insertBefore(tijdelijk, rijen[keuzes.length + 1] || null);
        zetWaarden(tijdelijk, w);
      }
      nummerRijen(laatsteBlok);
      Array.prototype.forEach.call(rijenVan(laatsteBlok), function (r) {
        var s = r.querySelector('[data-bundle-optie-naam]');
        if (s) stuur(s);
      });
    }

    /*
      Klik op een vakje van de staffelbalk (5 okt 2026): open meteen de
      bundel met dat aantal. Keuzes die de klant al maakte gaan mee.
        2 items  -> 2-stuks-kaart
        3 items  -> 3-stuks-kaart, extra rijen terug naar 3
        4+ items -> 3-stuks-kaart, aangevuld tot minstens 4 rijen
    */
    function kiesTrede(doel) {
      var huidig = zichtbaarBlok();
      var kaart = picker.querySelector('[data-bundle-optie][data-qty="' + doel + '"]');

      if (kaart && kaart !== laatsteKaart) {
        var r = kaart.querySelector('[data-bundle-radio]');
        if (!r.checked) {
          var oud = huidig ? Array.prototype.map.call(rijenVan(huidig), waardenVan) : null;
          r.checked = true;
          stuur(r);
          var nieuwBlok = zichtbaarBlok();
          if (oud && nieuwBlok) {
            var rijen = rijenVan(nieuwBlok);
            oud.forEach(function (w, i) { if (rijen[i]) { zetWaarden(rijen[i], w); stuur(rijen[i].querySelector('[data-bundle-optie-naam]')); } });
          }
        }
        return zichtbaarBlok();
      }

      /* 3 of meer: altijd de laatste kaart. */
      if (huidig && huidig !== laatsteBlok) {
        naarLaatsteKaart(huidig);
      } else if (!huidig) {
        var rl = laatsteKaart.querySelector('[data-bundle-radio]');
        rl.checked = true;
        stuur(rl);
      }
      var rijenL = rijenVan(laatsteBlok);
      if (doel <= basisAantal) {
        for (var i = rijenL.length - 1; i >= basisAantal; i--) rijenL[i].parentNode.removeChild(rijenL[i]);
        nummerRijen(laatsteBlok);
      } else {
        while (rijenVan(laatsteBlok).length < doel && rijenVan(laatsteBlok).length < maxStuks) voegRijToe(laatsteBlok);
      }
      return laatsteBlok;
    }

    picker.addEventListener('click', function (e) {
      var trede = e.target.closest && e.target.closest('[data-trede-qty]');
      if (trede) {
        e.preventDefault();
        var blokNa = kiesTrede(parseInt(trede.getAttribute('data-trede-qty'), 10) || 2);
        werkBij();
        if (blokNa && blokNa.getBoundingClientRect().bottom > window.innerHeight) {
          var knop = blokNa.querySelector('[data-bundle-meer]') || blokNa;
          knop.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
        return;
      }
      var meer = e.target.closest && e.target.closest('[data-bundle-meer]');
      if (meer) {
        e.preventDefault();
        var blok = meer.closest('[data-bundle-varianten]');
        if (blok === laatsteBlok) voegRijToe(blok);
        else naarLaatsteKaart(blok);
        werkBij();
        return;
      }
      var weg = e.target.closest && e.target.closest('[data-bundle-weg]');
      if (weg) {
        e.preventDefault();
        var rij = weg.closest('[data-bundle-item]');
        var b = weg.closest('[data-bundle-varianten]');
        if (rij && b && rijenVan(b).length > basisAantal) {
          rij.parentNode.removeChild(rij);
          nummerRijen(b);
          werkBij();
        }
      }
    });

    /* ---------- weergave ---------- */

    function werkBij() {
      var n = gekozenAantal();

      /* Staffelbalk */
      Array.prototype.forEach.call(picker.querySelectorAll('[data-trede-qty]'), function (t) {
        t.classList.toggle('is-behaald', n >= (parseInt(t.getAttribute('data-trede-qty'), 10) || 99));
      });

      /* 3-stuks-kaart volgt het echte aantal rijen */
      var nLaatste = rijenVan(laatsteBlok).length;
      var pctLaatste = pctVoor(nLaatste);
      if (titelEl) {
        titelEl.textContent = nLaatste === basisAantal
          ? basisTitel
          : basisTitel.replace(/^\s*\d+\s+Items?/i, nLaatste + ' Items');
      }
      var kortingEl = laatsteKaart.querySelector('[data-bundle-korting]');
      if (kortingEl) kortingEl.textContent = kortingTekst.replace('[discount]', pctLaatste + '%');
      var nuEl = laatsteKaart.querySelector('[data-bundle-nu]');
      var wasEl = laatsteKaart.querySelector('[data-bundle-was]');
      /* Shopify rekent de korting per stuk en rondt die naar beneden af. */
      var nuBedrag = nLaatste * (prijs - Math.floor(prijs * pctLaatste / 100));
      if (nuEl) nuEl.textContent = geld(nuBedrag);
      /* Max 50% claim (17 Oct 2026): doorgestreepte prijs nooit meer dan 2x
         wat de klant betaalt - eis van het Facebook-advertentieaccount. */
      if (wasEl) wasEl.textContent = geld(Math.min(vergelijk * nLaatste, nuBedrag * 2));

      /* Knoppen en regel eronder, per blok */
      Array.prototype.forEach.call(picker.querySelectorAll('[data-bundle-varianten]'), function (blok) {
        var aantal = rijenVan(blok).length;
        var knop = blok.querySelector('[data-bundle-meer]');
        var knopTekst = blok.querySelector('[data-bundle-meer-tekst]');
        var nudge = blok.querySelector('[data-bundle-nudge]');
        var straks = aantal + 1;
        var winst = '';
        var trede = staffel.filter(function (t) { return t.qty === straks; })[0];
        if (trede) winst = ' <span class="bundelkiezer__meer-winst">· Extra ' + trede.pct + '% off</span>';

        if (knop) {
          knop.hidden = aantal >= maxStuks;
          if (knopTekst) knopTekst.innerHTML = 'Add item ' + straks + winst;
        }

        if (nudge) {
          var nx = volgendeTrede(aantal);
          if (nx) {
            var tekort = nx.qty - aantal;
            nudge.classList.remove('is-max');
            nudge.innerHTML = 'Add <strong>' + tekort + ' more item' + (tekort > 1 ? 's' : '') +
              '</strong> to unlock an <strong>extra ' + nx.pct + '% off</strong>';
          } else {
            nudge.classList.add('is-max');
            nudge.innerHTML = 'Best deal unlocked: <strong>extra ' + pctVoor(aantal) + '% off</strong> every item';
          }
        }
      });
    }

    picker.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-bundle-radio]')) {
        setTimeout(werkBij, 0);
      }
    });

    werkBij();
  }

  function start() {
    document.querySelectorAll('[data-bundle-picker][data-bundle-builder]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
